import { render, staticRenderFns } from "./shipment-report-gov.vue?vue&type=template&id=7f6f82da&scoped=true&"
import script from "./shipment-report-gov.vue?vue&type=script&lang=js&"
export * from "./shipment-report-gov.vue?vue&type=script&lang=js&"
import style0 from "./shipment-report-gov.vue?vue&type=style&index=0&id=7f6f82da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6f82da",
  null
  
)

export default component.exports